export var LessonTypeEnum;
(function (LessonTypeEnum) {
    LessonTypeEnum["WEBINAR"] = "webinar";
    LessonTypeEnum["DEFAULT"] = "default";
    LessonTypeEnum["TEST"] = "test";
    LessonTypeEnum["HOMEWORK"] = "homework";
})(LessonTypeEnum || (LessonTypeEnum = {}));
